<template>
    <div class="home">
        <div id="left-login">
            <div id="logo-pic" class="flex-center">
                <img src="@/assets/outpost_logo.svg" alt="logo" />
            </div>
            <!-- <div id="logo-pic" @click="provera">
                <img src="@/assets/outpost_logo.svg" alt="logo" />
            </div> -->
            <div class="sm-show mobile-text flex-center">
                <p>Play Chess & Win Awards</p>
            </div>
            <!-- <div>
                <div class="sm-hide" id="welcom-text">
                    <p class="letter-44">Welcome to your</p>
                    <p class="letter-44 weight700">professional chess</p>
                    <p class="letter-44 weight700">community.</p>
                </div>
            </div> -->
            <div id="input-signup">
                <button
                    type="button"
                    class="text-join google-join"
                    style="border: 1px solid #e8e8e8"
                    @click="googleLogin"
                >
                    <div id="google-cor1">
                        <div id="google-cor">
                            <img id="" src="../assets/Group.svg" alt="google" />
                        </div>
                        <p id="joingoogle">Sign in with Google</p>
                    </div>
                </button>
                <div class="or-div">
                    <div class="horizontal-line"></div>
                    <div class="or-text" id="text-or">
                        or
                        <!-- <p class="or-text-deep" >or</p>   -->
                    </div>
                </div>
                <div id="mail">
                    <input
                        id="mail-input"
                        v-model="emailSignin"
                        type="email"
                        name=""
                        :class="{ mailin: isActive, 'text-danger': hasError }"
                        placeholder="Email"
                        @keyup.enter="signIn()"
                    />
                    <p class="reqpass">
                        {{ req1 }}
                    </p>
                </div>

                <div id="password-padd">
                    <input
                        v-model="passSignin"
                        type="password"
                        name=""
                        :class="{ mailin: isActive, 'text-danger': hasError2 }"
                        placeholder="Password"
                        @keyup.enter="signIn()"
                    />
                    <p class="reqpass">
                        {{ req }}
                    </p>
                    <p class="reqpass">
                        {{ request }}
                    </p>
                </div>

                <div id="butt1">
                    <button
                        type="button"
                        :class="{ 'bcg-brown': emailSignin.length > 5 && passSignin.length > 5 }"
                        class="text-join btn1"
                        style="border: 1px solid #c8a07d"
                        @click="signIn()"
                    >
                        Sign in
                    </button>
                </div>
                <div id="forgot-text">
                    <router-link to="/reset-password">
                        <p class="blue">Forgot password?</p>
                    </router-link>
                    <router-link to="/verification-mail">
                        <p class="blue">You didn't verify the email?</p>
                    </router-link>
                </div>
                <!-- <div class="or-div">
                    <div class="horizontal-line"></div>
                    <div class="or-text" id="text-or">or</div>
                </div> -->
                <!-- <p  id="text-or">or</p> -->

                <div id="policy">
                    <div class="or-div">
                        <div class="horizontal-line"></div>
                        <div class="or-text" id="text-or">or</div>
                    </div>
                    <!-- <p id="text-or">or</p> -->
                    <button type="button" class="text-join sign-up-btn" @click="back">
                        <p id="joingoogle">Sign up</p>
                    </button>
                </div>
            </div>
        </div>

        <div id="right-login" />
    </div>
</template>

<script>
import socketUtil from "../socket";
//import { version } from "../../package.json";

export default {
    name: "Signin",
    data() {
        return {
            passSignin: "",
            emailSignin: "",
            hush: "",
            req: "",
            req1: "",
            image1: "",
            isActive: true,
            hasError: false,
            hasError2: false,
            request: "",
            pojava: false,
            user: [],
            backendThinkVersion: "",
            afterLoginRoute: "",
        };
    },
    created() {},
    mounted() {
        if (window.location.href.includes("?state=")) {
            this.afterLoginRoute = window.location.href.split("?state=").pop();
        }

        this.emailSignin = this.$route.query.email;
        this.hush = this.$route.query.user_hash;

        if (this.emailSingin !== "" && this.hush !== "") {
            //console.log(this.emailSignin);
            //  console.log(this.hush);
            let hushRoute = this.hush;
            let emailoginRoute = this.emailSignin;
            window.Intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "qfb2wowv",
                email: emailoginRoute,
                isActiveEmail: true,
                user_hash: hushRoute,
            });
        }
        if (this.$cookies?.get("token")) {
            //document.cookie = document.cookie.split(';').filter(c => c.includes('token')).join(';')
            localStorage.removeItem("token");
            localStorage.setItem("token", this.$cookies.get("token"));
            let tokenId = JSON.parse(window.atob(this.$cookies.get("token").split(".")[1]));
            localStorage.setItem("id", tokenId.user_uuid);
            localStorage.setItem("H", tokenId.user_hash);
            localStorage.setItem("E", tokenId.email);
            // console.log("nulti", tokenId);
            // console.log("test1", this.$cookies.get("is_new_user"));
            //console.log("test2", localStorage.getItem("token"));
            let provera = tokenId.is_new_user;
            // console.log("check", provera);
            this.provera(provera);
        }
    },
    methods: {
        googleLogin() {
            fetch(process.env.VUE_APP_URL + "/get_google_auth_url", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
                .then(response => response.json())
                .then(data => (this.response = data))
                .then(data => console.log("podaci", data))
                .then(response => {
                    console.log("googleAuth", response);
                    location.replace(this.response.results);
                });
            this.provera();
        },
        back() {
            if (this.afterLoginRoute !== "" && this.afterLoginRoute !== 1 && this.afterLoginRoute !== "1") {
                this.$router.push({ path: `/?state=${this.afterLoginRoute}` });
            } else {
                this.$router.push("/");
            }
        },
        provera(e) {
            document.cookie = "token=; path=/; domain=.outpostchess.com; expires=" + new Date(0).toUTCString();

            this.$router.push("/");
            // console.log("test3", this.$cookies.get("token2"));
            // console.log("test4", localStorage.getItem("token"));
            //console.log("logedIn");

            if (e == true) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "signup",
                    pageUrl: "https://app.outpostchess.com/",
                    pageTitle: "OutpostChess",
                    method: "google",
                });

                let emailogin = localStorage.getItem("E");
                window.Intercom("boot", {
                    api_base: "https://api-iam.intercom.io",
                    app_id: "qfb2wowv",
                    email: emailogin, // Email address,
                    created_at: new Date(), // Signup date as a Unix timestamp
                    NewUser: new Date(),
                    isActiveEmail: false,
                    user_hash: localStorage.getItem("H"),
                });

                localStorage.removeItem("E");
                console.log("jhkuhkuhkhk");
                location.reload();
                this.$router.push("/");
            }
        },
        signIn() {
            (this.req = ""), (this.req1 = ""), (this.hasError2 = false), (this.hasError = false), (this.request = "");
            if (this.passSignin == "") {
                this.req = "Enter Password";
                this.hasError2 = true;
            }
            if (this.emailSignin == "") {
                this.req1 = " Enter Email";
                this.hasError = true;
            }
            if (this.emailSignin !== "" && this.passSignin !== "") {
                fetch(process.env.VUE_APP_URL + "/auth", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: this.emailSignin, password: this.passSignin }),
                })
                    .then(response => {
                        if (response.ok) {
                            // console.log('response.json()',response.json())
                            return response.json();
                        } else {
                            throw new Error("Something went wrong");
                        }
                    })
                    //  .then(data => console.log("app data toekne", data))

                    .then(data => {
                        // console.log("ok");
                        // Do something with the response
                        //   console.log("datica", data);
                        localStorage.setItem("token", data?.token);
                        localStorage.setItem("id", data?.results.user_uuid);
                        localStorage.setItem("H", data?.results.user_hash);
                        socketUtil.connect();
                        //  console.log('reg login',data?.results);

                        fetch(process.env.VUE_APP_URL + "/current_user_info", {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                        })
                            .then(response => response.json())
                            .then(data => (this.user = data))
                            // .then(data => console.log("app data", data))
                            .then(this.setNotificationInfo)
                            .then(this.setMessageInfo);
                        // .then(this.newVersion);
                    })

                    .catch(error => {
                        console.log("error");
                        console.log(error);
                        this.request = "Login failed.";
                        this.pojava = true;
                    });
            }
        },
        // newVersion() {
        //     fetch(process.env.VUE_APP_URL + "/frontend_version", {
        //         method: "GET",
        //         headers: {
        //             "Content-Type": "application/json",
        //             authorization: `Bearer ${localStorage.getItem("token")}`,
        //         },
        //     })
        //         .then(response => response.json())
        //         .then(data => (this.backendThinkVersion = data))
        //         // .then(data => console.log("backendThinkVersion", data))
        //         .then(this.checkVersion);
        // },

        // checkVersion() {

        //     if (version !== this.backendThinkVersion.version) {
        //         fetch(process.env.VUE_APP_URL + "/frontend_version", {
        //             method: "POST",
        //             headers: {
        //                 "Content-Type": "application/json",
        //                 authorization: `Bearer ${localStorage.getItem("token")}`,
        //             },
        //             body: JSON.stringify({
        //                 version: "0.1.10",
        //             }),
        //         });
        //         location.reload(true);
        //     }
        // },
        setMessageInfo() {
            /*    const firebaseConfig = {
                apiKey: "AIzaSyCQUZt6zFdh4abTOU6NuOk2gOsyOIBm90s",
                authDomain: "outpostchess-572a5.firebaseapp.com",
                projectId: "outpostchess-572a5",
                storageBucket: "outpostchess-572a5.appspot.com",
                messagingSenderId: "955489373658",
                appId: "1:955489373658:web:7fb0863b811f46e51844e3",
            };

            // Initialize Firebase
            const app = initializeApp(firebaseConfig);
            // Initialize Firebase Cloud Messaging and get a reference to the service
            const messaging = getMessaging(app);
            onMessage(messaging, payload => {
                console.log("Message received. ", payload);
                // alert("ide regular push");
            });
            const vapidKey = "BCafzu2wmzd5X7D_SfGiMO4NAVUr4fqbbnvlPloEHqfna3c01Ngjjrs1PbwjvD4dzyS853m-7FlpWHzinBykYnk";
            getToken(messaging, { vapidKey })
                .then(currentToken => {
                    if (currentToken) {
                        localStorage.setItem("tok_fire", currentToken);
                        console.log("currentToken", localStorage.getItem("tok_fire"));
                        fetch(process.env.VUE_APP_URL + "/firebase_registration_token", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                            body: JSON.stringify({
                                token: currentToken,
                            }),
                        });
                    } else {
                        // Show permission request UI
                        console.log("No registration token available. Request permission to generate one.");
                        // ...
                    }
                })
                .catch(err => {
                    console.log("An error occurred while retrieving token. ", err);
                    // ...
                });  */
            fetch(process.env.VUE_APP_URL + "/message", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())
                .then(data => (this.messages_contact_alert = data))
                .then(this.setUserData);
        },

        setUserData() {
            //  console.log('2',this.hush);
            let fullname = this.user.name_first + ` ` + this.user.name_last;
            let email = this.user.email;
            window.Intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "qfb2wowv",
                name: fullname, // Full name
                email: email, // Email address
                user_hash: localStorage.getItem("H"),
            });
            this.$store.commit("SET_USER_CURRENT", this.user);
            this.$store.commit("SET_MESSAGE_INFO", this.messages_contact_alert);
            if (this.afterLoginRoute == "" || this.afterLoginRoute == "1" || this.afterLoginRoute == 1) {
                this.$router.push(this.$route.query.redirect || "/home-page");
            } else {
                this.$router.push(`/tournament-inner/${this.afterLoginRoute}`);
            }

            //`/publicprofile/${this.user.user_uuid}`);
        },
    },
};
</script>
<style scoped lang="scss">
p {
    padding: 0;
}
a {
    text-decoration: none;
}

.home {
    background-color: #1b1b1c;
    display: grid;
    grid-template-columns: 50% 50%;
    min-height: 100vh;
}
.horizontal-line {
    position: relative;
    height: 38px;
    width: 75%;
    top: 19px;
    left: 12.5%;
    border-top: 1px solid rgba(125, 120, 115, 0.5);
    @media only screen and (max-width: 640px) {
        width: 100%;
        left: 0%;
    }
}

.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.letter-44 {
    display: flex;
    color: #ffffff;
    font-size: 44px;
    line-height: 55px;
    @media only screen and (max-width: 1366px) {
        font-size: 38px;
        line-height: 48px;
    }
}

.home-p {
    color: #707070;
    margin-top: 0.625rem;
    font-size: 12px;
    line-height: 12px;
}
.blue {
    color: #11c6d1;
    font-size: 12px;
    margin: 0px;
}
.pass-in {
    border: 1px solid rgba(196, 196, 196, 0.5);
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #1b1c1d;
    height: 40px;
    padding-left: 15px;
    color: #ffffff;
}

.text-join {
    font-size: 15px;
    color: #ffffff;
    background-color: #1b1c1d;
    width: 75%;
    box-sizing: border-box;
    border-radius: 6px;
    height: 44px;
}
.text-join:hover {
    opacity: 0.7;
}

#right-login {
    background-image: url("../assets/loginphoto.jpg");
    width: 100%;
    background-size: cover;
    background-position: center;
    color: #707070;
    background-color: #1b1c1d;
}
#forgot-text {
    width: 60%;
    position: relative;
    left: 12.5%;
    margin: 15px 0px;
    text-align: left;
    @media only screen and (max-width: 640px) {
        left: 0%;
    }
}
.google-join {
    background-color: #ffffff !important;
    border: 1px solid #707070 !important;
    &:hover {
        opacity: 0.7 !important;
    }
}
#welcom-text > p {
    margin: 0;
    padding-left: 29%;
    @media only screen and (max-width: 1440px) {
        padding-left: 26%;
    }
}
#welcom-text {
    margin: 30px 0 30px 0;
}

#left-login {
    background-color: #1b1b1c;
    padding-top: 70px;
    @media only screen and (max-width: 1680px) {
        padding-top: 40px;
    }
    @media only screen and (max-width: 1536px) {
        padding-top: 20px;
    }
    @media only screen and (max-width: 1440px) {
        padding-top: 34px;
    }
    @media only screen and (max-width: 1366px) {
        padding-top: 20px;
    }
}
#logo-pic {
    padding: 40px 0 10px 0;
    width: 100%;
    display: flex;
    @media only screen and (max-width: 1440px) {
        //  margin-left: 26%;
    }
    @media only screen and (max-width: 1366px) {
        // padding: 30px 35px 0px 0px;
    }
    // margin-left: 29%;
    img {
        width: 176px;
    }
}
.or-div {
    position: relative;
    margin-top: 12px;
    margin-bottom: 12px;
}
.or-text {
    position: absolute;
    bottom: 2.5px;
    font-size: 13px;
    width: 6%;
    left: 47.5%;
    padding: 0 15px;
    display: flex;
    justify-content: center;
    background-color: #1b1b1c;
    @media only screen and (max-width: 640px) {
        width: 10%;
        left: 45%;
    }
}
input::placeholder {
    font-size: 15px;
}
.sign-up-btn {
    border: 1px solid #e8e8e8;
    &:hover {
        border: 1px solid #c8a07d;
    }
}
.btn1 {
    border: 1px solid #c8a07d !important;
    font-weight: 600;
    margin-top: 12px;
    &:hover {
        background-color: #1b1c1d !important;
        opacity: 1;
    }
}
#input-signup {
    background-color: #1b1c1d;
    width: 78%;
    padding: 10px 0 20px 0;
    margin: auto;
    border-radius: 11px;
    @media only screen and (max-width: 640px) {
        width: 75%;
    }
}
#letter-16 {
    color: #ffffff;
    font-size: 16px;
}

.mailin {
    width: 75%;
    border: 1px solid rgba(196, 196, 196, 0.5);
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #1b1c1d;
    height: 40px;
    padding-left: 15px;
    font-size: 15px;
    color: #ffffff;
}
.bcg-brown {
    background-color: #c8a07d !important;
}
.text-danger {
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #1b1c1d;
    height: 40px;
    padding-left: 15px;
    font-size: 15px;
    border: 1px solid #f2358d;
    color: #ffffff;
    color: #ffffff !important;
}

#text-or {
    font-size: 15px;
    color: #ffffff;
    padding: 0.4rem 0;
}
#text-or p {
    margin-bottom: 0 !important;
}
p {
    margin-bottom: 0 !important;
}

.mobile-text {
    margin-top: 14px;
    margin-bottom: 30px;
    color: #ceceda;

    font-weight: 700;
    p {
        font-size: 24px;
        @media only screen and (max-width: 640px) {
            font-size: 20px;
        }
    }
    @media only screen and (max-width: 640px) {
        margin-bottom: 20px;
    }
}
#google-cor1 {
    display: flex;
    justify-content: center;
    align-items: center;
    p {
        color: #1b1b1c;
    }
}
#google-cor {
    width: 20px;
    margin: auto 0 auto 0;
    padding-right: 7px;
}
.reqpass {
    color: #f2358d;
    text-align: left;

    justify-content: left;
    font-size: 12px;
    margin-left: 12.5%;
    @media only screen and (max-width: 640px) {
        margin-left: 0%;
    }
}
#joingoogle {
    margin: 0;
    padding-left: 10px;
    font-weight: 600;
}
#signup {
    text-align: left;

    padding-right: 50%;
}
#password-padd {
    margin-top: 1rem;
}

@media screen and (min-width: 1149px) and (max-width: 1440px) {
    #password-padd {
        padding: 0;
    }
    #welcom-text {
        margin: 20px 0 0 0;
    }

    p {
        margin: 10px;
    }
}

@media screen and (min-width: 951px) and (max-width: 1148px) {
    .letter-44 {
        font-size: 28px;
    }
}
@media only screen and (max-width: 950px) {
    #right-login {
        display: none;
    }
    .home {
        display: flex;
        width: 100vw;
    }
    .letter-44 {
        font-size: 24px;
    }
    #left-login {
        width: 100%;
    }

    #logo-pic {
        display: flex;
    }
}
@media only screen and (max-width: 640px) {
    #logo-pic > img {
        height: 5.5rem;
    }
    #logo-pic {
        //  margin-left: 20%;
    }
    #input-signup {
        width: 80%;
    }

    .mailin {
        width: 100%;
    }

    .text-danger {
        width: 100%;
    }
    #welcom-text > p {
        margin: 0;
        padding-left: 20%;
    }
    #logo-pic {
        img {
            width: 176px;
        }
        // padding: 20px 35px 0px 0;
    }
    .text-join {
        width: 100%;
    }
}
</style>
